import React from 'react';

import { filterIsApplied, FilterMenu } from '@vlabs/monokit/shared/ui/filter-menu';
import { Control } from '@vlabs/uikit';
import { omit } from 'lodash';
import { useTranslation } from 'react-i18next';

/* eslint-disable import-x/no-namespace */
import * as sideMenuFilters from './side-menu';
import { useListFacesPageFilters } from '../../useListDetailsFilters';

function ListFacesFilterMenu(): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, resetFilters } = useListFacesPageFilters();

  const isResetDisabled = Object.values(
    omit(filters, 'pageIndex', 'pageSize'),
  ).filter((v) => v !== undefined && v !== '').length === 0;

  return (
    <FilterMenu
      filters={[
        <sideMenuFilters.DateFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.create_time__lt ?? filters.create_time__gte))}
          key="create_time"
          value={t('list-details-page:filters.popovers.date')}
        />,
        <sideMenuFilters.FaceIdsFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.face_ids))}
          key="face_ids"
          value={t('list-details-page:filters.popovers.face_ids')}
        />,
        <sideMenuFilters.UserDataFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.user_data))}
          key="user_data"
          value={t('list-details-page:filters.popovers.user_data')}
        />,
      ]}
      footer={(
        <Control.Button
          data-testid="button.reset-list-filters"
          disabled={isResetDisabled}
          fullWidth
          kind="negative"
          onClick={() => resetFilters()}
          type="button"
        >
          {t('list-details-page:filters.buttons.reset button')}
        </Control.Button>
      )}
    />
  );
}

export { ListFacesFilterMenu };
